export function StatusBadge({ status }: { status: string }) {
  const colorClass: Record<string, string> = {
    active: 'green',
    pending: 'yellow',
    invited: 'yellow',
    paused: 'orange',
    suspended: 'red',
    deleted: 'red',
  };

  return (
    <span className={`status-badge ${colorClass[status] || 'gray'}`}>
      {status}
    </span>
  );
}
